import mapboxgl from "mapbox-gl";
import { MapRequests } from "./requests.ts";
import { toast } from 'react-toastify';
import config from '../../Config/config.json';
import { store } from "../../Redux/Store";
import { getEquipamentTime } from "../../util/Months";
import { ChangeButtonsMap, ChangeEquipamentDataList, ChangeMapData, ChangeMapEquipment, ChangeMapLoading, ChangeMapState, LogOut, changeModal } from "../../Redux/Actions";
import { MapMarkerGreen, MapMarkerYellow, MapMarkerRed, MapMarkerOrange, MapMarkerPurple, ReservatorioGreen, ReservatorioRed, ReservatorioYellow, ReservatorioPurple, 
    ReservatorioOrange, VazaoGreen, VazaoRed, VazaoYellow, VazaoPurple, VazaoGray, LevelGreen, LevelRed, LevelYellow, LevelPurple, LevelGray,
    PressureGreen, PressureRed, PressureYellow, PressurePurple, PressureGray, PocoGreen, PocoRed, PocoOrange, PocoPurple, PocoYellow, PocoGray,
    ETAGreen, ETARed, ETAOrange, ETAPurple, ETAYellow, ETAGray, GeneralIconGray, GeneralIconGreen, GeneralIconRed, GeneralIconYellow, GeneralIconPurple, 
    GeneralIconOrange, AbsorptionBarrier, TurbidityBarrier, DustSuppressor} from "../../Assets/icons/MapIcons";
import i18n from "../../Config/i18n.js";

/**
 * Classe para gerenciamento do mapa
 */
export class MapService {
    constructor(mapContainer, navigate) {
        this.mapRequests = new MapRequests();
        this.map = null;
        this.markers = {};
        this.markersOnScreen = {};
        this.accessToken = 'pk.eyJ1IjoiYXVnZW5lbmdlbmhhcmlhIiwiYSI6ImNsZjJndWZ6YjBieHIzcnFwMTE3ZnZhMDUifQ.vXY4O2xgCvVyVA9BtI79mQ';
        this.style = 'mapbox://styles/augenengenharia/clf2kkzoh000901w34rdkrck6';
        this.status = [
            ['==', ['get', 'status'], 0], 
            ['==', ['get', 'status'], 1], 
            ['==', ['get', 'status'], 2], 
            ['==', ['get', 'status'], 3], 
            ['==', ['get', 'status'], 4],
            ['==', ['get', 'status'], 5]
        ];
        this.colors = ["#3C9", "#EABC1A", "#FF3939", '#6600CC', '#E1800E', '#A3A3A3'];
        this.mapContainer = mapContainer;
        this.center = [-52.1600, -32.0600];
        this.data = null;
        this.navigate = navigate; 
        this.areasShow = [];
        this.openPopups = [];
        this.popupData = [];
        this.popup = null;
        this.tourFlagChecked = true;
        this.isTourOpen = false;
        this.priority = [
            'Fluoreto',
            'Cloro Livre',
            'Turbidez Tratada',
            'Cor Tratada',
            'Turbidez Bruta',
            'Cor Bruta',
            'Turbidez Filtrada 1', 'Turbidez Filtrada 2', 'Turbidez Filtrada 3', 'Turbidez Filtrada 4',
            'Cor Filtrada 1', 'Cor Filtrada 2', 'Cor Filtrada 3', 'Cor Filtrada 4',
            'pHmetro', 'pHmetro 1', 'pHmetro 2', 'pHmetro 3',
            'Temperatura', 'Temperatura 1', 'Temperatura 2', 'Temperatura 3',
            'Macro vazão', 'Macro diário',
            'Nível', 'Pressão', 'Pressão 2',
            'Diferencial de pressão',
        ];
        this.checkRequest = {};
    }

    setTour(isOpen){
        this.isTourOpen = isOpen;
        return this.isTourOpen;
    }

    /**
     * Inicia o mapa
     */
    async start(){
        try {
            let data = await this.mapRequests.MainRequest();  
            await this.createList(data);
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return
        }

        if(this.map){
            this.map.remove();
        }
        this.addImages();
        
        mapboxgl.accessToken = this.accessToken;
        this.map = new mapboxgl.Map({
            container: this.mapContainer,
            style: this.style,
            center: this.center,
            pitch: 50,
            bearing: 0,
            zoom: 12.5,
            minZoom: 2.5,
        });
        this.loadMapTemplate();
        this.updatefixedList();
    }

    /**
     * Reinicia o mapa
     */
    async restart(){
        try {
            let data = await this.mapRequests.MainRequest();  
            await this.createList(data);
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return
        }
        await this.removeMap();
        await this.addSource();
        await this.addLayers();
        this.areasShow.map(id=>{
            this.map.setFeatureState(
                { source: 'Area', id: id },
                { ShowArea: true }
            );
            return id
        })
        this.updatePopups();
        this.updatefixedList();
    }

    /**
     * Carrega as Imagens do mapa
     */
    addImages(){
        // Imagens de equipamentos
        try {
            let green = new Image(108, 44);
            green.onload = ()=> this.map.addImage('green', green);
            green.src = MapMarkerGreen;

            let yellow = new Image(105, 44);
            yellow.onload = ()=> this.map.addImage('yellow', yellow);
            yellow.src = MapMarkerYellow;

            let red = new Image(105, 44);
            red.onload = ()=> this.map.addImage('red', red);
            red.src = MapMarkerRed;

            let orange = new Image(105, 44);
            orange.onload = ()=> this.map.addImage('orange', orange);
            orange.src = MapMarkerOrange;

            let purple = new Image(105, 44);
            purple.onload = ()=> this.map.addImage('purple', purple);
            purple.src = MapMarkerPurple;
        } catch (error) {
            console.log(error+'Ao carregar as imagens dos equipamentos')
        }

        // Analisadores
        try {
            let generalGreen = new Image(45, 45);
            generalGreen.onload = ()=> this.map.addImage('generalGreen', generalGreen);
            generalGreen.src = GeneralIconGreen;

            let generalYellow = new Image(45, 45);
            generalYellow.onload = ()=> this.map.addImage('generalYellow', generalYellow);
            generalYellow.src = GeneralIconYellow;

            let generalRed = new Image(45, 45);
            generalRed.onload = ()=> this.map.addImage('generalRed', generalRed);
            generalRed.src = GeneralIconRed;

            let generalOrange = new Image(45, 45);
            generalOrange.onload = ()=> this.map.addImage('generalOrange', generalOrange);
            generalOrange.src = GeneralIconOrange;

            let generalPurple = new Image(45, 45);
            generalPurple.onload = ()=> this.map.addImage('generalPurple', generalPurple);
            generalPurple.src = GeneralIconPurple;

            let generalIconGray = new Image(45, 45);
            generalIconGray.onload = ()=> this.map.addImage('generalIconGray', generalIconGray);
            generalIconGray.src = GeneralIconGray;
        } catch (error) {
            console.log(error+'Ao carregar as imagens dos analisadores')
        }

        // Poços
        try {
            let pocoGreen = new Image(55, 80);
            pocoGreen.onload = ()=> this.map.addImage('pocoGreen', pocoGreen);
            pocoGreen.src = PocoGreen;

            let pocoRed = new Image(55, 80);
            pocoRed.onload = ()=> this.map.addImage('pocoRed', pocoRed);
            pocoRed.src = PocoRed;

            let pocoYellow = new Image(55, 80);
            pocoYellow.onload = ()=> this.map.addImage('pocoYellow', pocoYellow);
            pocoYellow.src = PocoYellow;

            let pocoPurple = new Image(55, 80);
            pocoPurple.onload = ()=> this.map.addImage('pocoPurple', pocoPurple);
            pocoPurple.src = PocoPurple;

            let pocoOrange = new Image(55, 80);
            pocoOrange.onload = ()=> this.map.addImage('pocoOrange', pocoOrange);
            pocoOrange.src = PocoOrange;

            let pocoGray = new Image(55, 80);
            pocoGray.onload = ()=> this.map.addImage('pocoGray', pocoGray);
            pocoGray.src = PocoGray;
        } catch (error) {
            console.log(error+'Ao carregar as imagens dos poços')
        }

        // ETAs
        try {
            let etaGreen = new Image(150, 75);
            etaGreen.onload = ()=> this.map.addImage('etaGreen', etaGreen);
            etaGreen.src = ETAGreen;

            let etaRed = new Image(150, 75);
            etaRed.onload = ()=> this.map.addImage('etaRed', etaRed);
            etaRed.src = ETARed;

            let etaYellow = new Image(150, 75);
            etaYellow.onload = ()=> this.map.addImage('etaYellow', etaYellow);
            etaYellow.src = ETAYellow;

            let etaPurple = new Image(150, 75);
            etaPurple.onload = ()=> this.map.addImage('etaPurple', etaPurple);
            etaPurple.src = ETAPurple;

            let etaOrange = new Image(150, 75);
            etaOrange.onload = ()=> this.map.addImage('etaOrange', etaOrange);
            etaOrange.src = ETAOrange;

            let etaGray = new Image(150, 75);
            etaGray.onload = ()=> this.map.addImage('etaGray', etaGray);
            etaGray.src = ETAGray;

        } catch (error) {
            console.log(error+'Ao carregar as imagens das ETAs')
        }

        // Reservatórios
        try {
            let reservatoriogreen = new Image(42, 50);
            reservatoriogreen.onload = ()=> this.map.addImage('reservatoriogreen', reservatoriogreen);
            reservatoriogreen.src = ReservatorioGreen;

            let reservatorioRed = new Image(42, 50);
            reservatorioRed.onload = ()=> this.map.addImage('reservatorioRed', reservatorioRed);
            reservatorioRed.src = ReservatorioRed;

            let reservatorioYellow = new Image(42, 50);
            reservatorioYellow.onload = ()=> this.map.addImage('reservatorioYellow', reservatorioYellow);
            reservatorioYellow.src = ReservatorioYellow;

            let reservatorioPurple = new Image(42, 50);
            reservatorioPurple.onload = ()=> this.map.addImage('reservatorioPurple', reservatorioPurple);
            reservatorioPurple.src = ReservatorioPurple;

            let reservatorioOrange = new Image(42, 50);
            reservatorioOrange.onload = ()=> this.map.addImage('reservatorioOrange', reservatorioOrange);
            reservatorioOrange.src = ReservatorioOrange;

        } catch (error) {
            console.log(error+'Ao carregar as imagens dos reservatórios')
        }

        // Macro medidores
        try {
            let vazaoGreen = new Image(50, 28);
            vazaoGreen.onload = ()=> this.map.addImage('vazaoGreen', vazaoGreen);
            vazaoGreen.src = VazaoGreen;
    
            let vazaoRed = new Image(50, 28);
            vazaoRed.onload = ()=> this.map.addImage('vazaoRed', vazaoRed);
            vazaoRed.src = VazaoRed;
    
            let vazaoYellow = new Image(50, 28);
            vazaoYellow.onload = ()=> this.map.addImage('vazaoYellow', vazaoYellow);
            vazaoYellow.src = VazaoYellow;
    
            let vazaoPurple = new Image(50, 28);
            vazaoPurple.onload = ()=> this.map.addImage('vazaoPurple', vazaoPurple);
            vazaoPurple.src = VazaoPurple;
    
            let vazaoGray = new Image(50, 28);
            vazaoGray.onload = ()=> this.map.addImage('vazaoGray', vazaoGray);
            vazaoGray.src = VazaoGray;
        } catch (error) {
            console.log(error+'Ao carregar as imagens dos macro medidores')
        }

        // Sensores de nível
        try {
            let levelGreen = new Image(28, 50);
            levelGreen.onload = ()=> this.map.addImage('levelGreen', levelGreen);
            levelGreen.src = LevelGreen;
    
            let levelRed = new Image(28, 50);
            levelRed.onload = ()=> this.map.addImage('levelRed', levelRed);
            levelRed.src = LevelRed;
    
            let levelYellow = new Image(28, 50);
            levelYellow.onload = ()=> this.map.addImage('levelYellow', levelYellow);
            levelYellow.src = LevelYellow;
    
            let levelPurple = new Image(28, 50);
            levelPurple.onload = ()=> this.map.addImage('levelPurple', levelPurple);
            levelPurple.src = LevelPurple;
    
            let levelGray = new Image(28, 50);
            levelGray.onload = ()=> this.map.addImage('levelGray', levelGray);
            levelGray.src = LevelGray;
        } catch (error) {
            console.log(error+'Ao carregar as imagens dos sensores de nível')
        }

        // Sensores de pressão
        try {
            let pressureGreen = new Image(53, 40);
            pressureGreen.onload = ()=> this.map.addImage('pressureGreen', pressureGreen);
            pressureGreen.src = PressureGreen;

            let pressureRed = new Image(53, 40);
            pressureRed.onload = ()=> this.map.addImage('pressureRed', pressureRed);
            pressureRed.src = PressureRed;

            let pressureYellow = new Image(53, 40);
            pressureYellow.onload = ()=> this.map.addImage('pressureYellow', pressureYellow);
            pressureYellow.src = PressureYellow;

            let pressurePurple = new Image(53, 40);
            pressurePurple.onload = ()=> this.map.addImage('pressurePurple', pressurePurple);
            pressurePurple.src = PressurePurple;

            let pressureGray = new Image(53, 40);
            pressureGray.onload = ()=> this.map.addImage('pressureGray', pressureGray);
            pressureGray.src = PressureGray;
        } catch (error) {
            console.log(error+'Ao carregar as imagens dos sensores de pressão')
        }

        // Bio
        try {
            let absorptionBarrier = new Image(50, 50);
            absorptionBarrier.onload = ()=> this.map.addImage('absorptionBarrier', absorptionBarrier);
            absorptionBarrier.src = AbsorptionBarrier;

            let turbidityBarrier = new Image(50, 50);
            turbidityBarrier.onload = ()=> this.map.addImage('turbidityBarrier', turbidityBarrier);
            turbidityBarrier.src = TurbidityBarrier;

            let dustSuppressor = new Image(50, 50);
            dustSuppressor.onload = ()=> this.map.addImage('dustSuppressor', dustSuppressor);
            dustSuppressor.src = DustSuppressor;
        } catch (error) {
            console.log(error+'Ao carregar as imagens dos equipamentos de bio')
        }
    }

    /**
     * Remove os elementos do mapa
     */
    async removeMap(){
        try {
            if(this.map.getLayer('unclustered-modulos')){
                this.map.removeLayer('unclustered-modulos')
            }
            if(this.map.getLayer('unclustered-equipamentos')){
                this.map.removeLayer('unclustered-equipamentos')
            }
            if(this.map.getLayer('unclustered-Poco')){
                this.map.removeLayer('unclustered-Poco')
            }
            if(this.map.getLayer('unclustered-eta')){
                this.map.removeLayer('unclustered-eta')
            }
            if(this.map.getLayer('unclustered-reservatorio')){
                this.map.removeLayer('unclustered-reservatorio')
            }
            if(this.map.getLayer('unclustered-Macro')){
                this.map.removeLayer('unclustered-Macro')
            }
            if(this.map.getLayer('unclustered-level')){
                this.map.removeLayer('unclustered-level')
            }
            if(this.map.getLayer('unclustered-pressure')){
                this.map.removeLayer('unclustered-pressure')
            }
            if(this.map.getLayer('Text-white')){
                this.map.removeLayer('Text-white')
            }
            if(this.map.getLayer('Text-Blue')){
                this.map.removeLayer('Text-Blue')
            }
            if(this.map.getLayer('clusters')){
                this.map.removeLayer('clusters')
            }
            if(this.map.getLayer('borders')){
                this.map.removeLayer('borders')
            }
            if(this.map.getLayer('Area-fills')){
                this.map.removeLayer('Area-fills')
            }
            if(this.map.getLayer('supply-lines-layer')){
                this.map.removeLayer('supply-lines-layer')
            }
            if(this.map.getLayer('unclustered-response')){
                this.map.removeLayer('unclustered-response')
            }
            if(this.map.getLayer('unclustered-dust')){
                this.map.removeLayer('unclustered-dust')
            }
            if(this.map.getLayer('unclustered-mpf')){
                this.map.removeLayer('unclustered-mpf')
            }
            if(this.map.getSource('points')){
                this.map.removeSource('points')
            }
            if(this.map.getSource('Area')){
                this.map.removeSource('Area')
            }
            if(this.map.getSource('supply-lines')){
                this.map.removeSource('supply-lines')
            }
        } catch (error) {
            console.log(error)
        }
    }

    /**
     * Carrega o conteudo do mapa
     */
    loadMapTemplate(){
        try {
            this.map.on('load', async () => {
                await this.addSource();
                await this.addLayers();

                let layers = ['unclustered-modulos', 'unclustered-equipamentos', 'unclustered-Poco', 
                    'unclustered-eta', 'unclustered-eta-custom', 'unclustered-reservatorio', 'unclustered-Macro', 'unclustered-level', 
                    'unclustered-pressure', 'Text-Blue', 'Text-white']

                this.map.on('click', layers, (e) => {
                    const coordinates = e.features[0].geometry.coordinates.slice();
                    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                    }
                    if( e.features[0].properties.type !== 'TEMPGROUP'){
                        this.GetEquipmentData(e.features[0].properties.id, coordinates, e.features[0].properties)
                    }else{
                        this.GetEquipmentData(e.features[0].properties.id, coordinates, e.features[0].properties, true)
                    }
                    this.checkAndChangeArea(e.features[0].properties)
                })

                this.map.on('dblclick', layers, (e) => {
                    if(e.features[0].properties.type !== 'TEMPGROUP' && e.features[0].properties.type !== "8831aa23-aa96-468f-bd48-10463cdaea6b"){
                        this.openModal(e.features[0].properties, true)
                    }else if( e.features[0].properties.type !== 'TEMPGROUP'){
                        this.openModal(e.features[0].properties)
                    }else{
                        this.openModal(e.features[0].properties, false, true)
                    }
                })

                // Hover
                this.map.on('mousemove', [...layers, 'supply-lines-layer'], (e) => {
                    if (e.features.length > 0) {
                        this.map.setFeatureState(
                            { source: 'supply-lines', id: e.features[0].properties.id },
                            { Active: true }
                        );
                    }
                });

                this.map.on('mouseleave', [...layers, 'supply-lines-layer'], () => {
                    this.Lines.features.map(line=>{
                        this.map.setFeatureState(
                            { source: 'supply-lines', id: line.properties.id },
                            { Active: false }
                        );
                        return line
                    })
                });

                // Atualiza os marcadores e gráficos caso haja alteração nos dados ou movimento no mapa
                this.map.on('data', () => {
                    this.updateMarkers();
                })
                
                this.map.on('move', () => {
                    this.updateMarkers();
                });

                this.map.on("mouseenter", layers, () => {
                    this.map.getCanvas().style.cursor = "pointer";
                });
          
                this.map.on("mouseleave", layers, () => {
                    this.map.getCanvas().style.cursor = "grab";
                });
            })
        } catch (error) {
            console.log(error)
        }
    }

    // Abre o modal com botões da dash e do controle conforme a flag
    openModal(equipament, controlFlag, groupFlag){
        store.dispatch(ChangeButtonsMap({
            dash: true,
            control: controlFlag,
        }))
        store.dispatch(ChangeMapLoading(true))
        store.dispatch(ChangeMapEquipment({
            nome: equipament.name,
            id: equipament.id,
        }))
        store.dispatch(changeModal('mapmodal'))

        this.GetEquipmentData(equipament.id, null, null, groupFlag)
    }

    // Atualiza as areas do mapa
    checkAndChangeArea(area){
        if(this.areasShow.includes(area.id)){
            this.map.setFeatureState(
                { source: 'Area', id: area.id},
                { ShowArea: false }
            );
            let index = this.areasShow.indexOf(area.id);
            this.areasShow.splice(index, 1);
        }else{
            this.areasShow.push(area.id)
            this.map.setFeatureState(
                { source: 'Area', id: area.id },
                { ShowArea: true }
            );
        }
    }

    /**
     * Atualiza os marcadores do mapa
     */
    updateMarkers() {
        const newMarkers = {};
        const features = this.map.querySourceFeatures('points') ;

        for (const feature of features) {
            const coords = feature.geometry.coordinates;
            const props = feature.properties;
            if (!props.cluster) continue;
            const id = props.cluster_id;
            
            let marker = this.markers[id];
            if (!marker) {
                const el = this.createDonutChart(props);
                marker = this.markers[id] = new mapboxgl.Marker({
                    element: el,
                }).setLngLat(coords);
                marker.props = props;

            }else if(id === marker.props.cluster_id && 
            (marker.props.status0 !== props.status0 ||
            marker.props.status1 !== props.status1 ||
            marker.props.status2 !== props.status2 ||
            marker.props.status3 !== props.status3 ||
            marker.props.status4 !== props.status4)){
                marker.remove();
                const el = this.createDonutChart(props);
                marker = this.markers[id] = new mapboxgl.Marker({
                    element: el,
                }).setLngLat(coords);
                marker.props = props;
                marker.addTo(this.map);
            }
            newMarkers[id] = marker;
            
            if (!this.markersOnScreen[id]) marker.addTo(this.map);
        }

        for (const id in this.markersOnScreen) {
            if (!newMarkers[id]) this.markersOnScreen[id].remove();
        }
        this.markersOnScreen = newMarkers;
    }

    /**
     * Cria o gráfico para marcadores agrupados
     * @param {Object} props 
     * @returns {HTMLElement} Gráfico
     */
    createDonutChart(props) {
        const offsets = [];
        const counts = [
            props.status0,
            props.status1,
            props.status2,
            props.status3,
            props.status4,
            props.status5,
        ];
        let total = 0;
        for (const count of counts) {
            offsets.push(total);
            total += count;
        }
        const fontSize =
            total >= 1000 ? 22 : total >= 100 ? 20 : total >= 10 ? 18 : 16;
        const r =
            total >= 1000 ? 50 : total >= 100 ? 32 : total >= 10 ? 24 : 18;
        const r0 = Math.round(r * 0.6);
        const w = r * 2;
        
        let html = `<div>
            <svg width="${w}" height="${w}" viewbox="0 0 ${w} ${w}" text-anchor="middle" style="font: ${fontSize}px sans-serif; display: block">`;
        try {
            for (let i = 0; i < counts.length; i++) {
                html += this.donutSegment(
                    offsets[i] / total,
                    (offsets[i] + counts[i]) / total,
                    r,
                    r0,
                    this.colors[i]
                );
            }
        } catch (error) {
            console.log(error)
        }
        html += `<circle cx="${r}" cy="${r}" r="${r0}" fill="white" />
        <text dominant-baseline="central" transform="translate(${r}, ${r})">
        ${total.toLocaleString()}
        </text>
        </svg>
        </div>`;
        
        const el = document.createElement('div');
        el.innerHTML = html;
        return el.firstChild;
    }

    /**
     * Cria o gráfico para marcadores agrupados
     * @param {Int} start Começo do segmento
     * @param {Int} end final do segmento
     * @param {Int} r raio para path do segmento
     * @param {Int} r0 raio inicial para path do segmento
     * @param {string} color cor do segmento
     * @returns {HTMLElement} Segmento do gráfico
     */
    donutSegment(start, end, r, r0, color) {           
        if (end - start === 1) end -= 0.00001;
        const a0 = 2 * Math.PI * (start - 0.25);
        const a1 = 2 * Math.PI * (end - 0.25);
        const x0 = Math.cos(a0),
        y0 = Math.sin(a0);
        const x1 = Math.cos(a1),
        y1 = Math.sin(a1);
        const largeArc = end - start > 0.5 ? 1 : 0;
        
        // draw an SVG path
        return `<path d="M ${r + r0 * x0} ${r + r0 * y0} L ${r + r * x0} ${
        r + r * y0
        } A ${r} ${r} 0 ${largeArc} 1 ${r + r * x1} ${r + r * y1} L ${
        r + r0 * x1
        } ${r + r0 * y1} A ${r0} ${r0} 0 ${largeArc} 0 ${r + r0 * x0} ${
        r + r0 * y0
        }" fill="${color}" />`;
    }

    /**
     * Adiciona Source ao mapa
     */
    async addSource (){
        await this.removeMap();
        
        // Source com os equipamentos
        this.map.addSource('points', {
            'type': 'geojson',
            'data': {
                'type': 'FeatureCollection',
                'features': this.data
            },
            'cluster': true,
            'clusterMaxZoom': 14, // Define o zoom máximo para a exibição de clusters
            'clusterRadius': 50, // Define o raio para agrupar pontos em clusters
            'clusterProperties': {
                // Contadores separados para cada status
                'status0': ['+', ['case', this.status[0], 1, 0]],
                'status1': ['+', ['case', this.status[1], 1, 0]],
                'status2': ['+', ['case', this.status[2], 1, 0]],
                'status3': ['+', ['case', this.status[3], 1, 0]],
                'status4': ['+', ['case', this.status[4], 1, 0]],
                'status5': ['+', ['case', this.status[5], 1, 0]]
            }
        });

        // Source com as areas 
        this.map.addSource('Area', {
            'type': 'geojson',
            'data':  this.Areas,
            "promoteId": "id"
        });

        // Source com as linhas de distribuição
        this.map.addSource('supply-lines',{
            'type': 'geojson',
            'data': this.Lines,
            "promoteId": "id"
        })
    }

    /**
     * Adiciona as camadas necessárias ao mapa
     */
    async addLayers (){
        // Layer para linhas entre equipamentos
        this.map.addLayer({
            'id': 'supply-lines-layer',
            'type': 'line',
            'source': 'supply-lines',
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
            },
            'paint': {
                'line-color': '#A1AEC9',
                'line-width': 6,
                'line-opacity': [
                    'case',
                    ['boolean', ['feature-state', 'Active'], false],
                    1, 
                    0  
                ],
            },
            minzoom: 10
        });

        // Preenchimento da area
        this.map.addLayer({
            'id': 'Area-fills',
            'type': 'fill',
            'source': 'Area',
            'layout': {},
            'paint': {
                'fill-color': [
                    'case',
                    this.status[0],
                    '#3C9',
                    this.status[1],
                    '#EABC1A',
                    this.status[2],
                    '#FF3939',
                    this.status[3],
                    '#6600CC',
                    this.status[4],
                    '#E1800E',
                    '#F6F6F6'
                ],
                'fill-opacity': [
                    'case',
                    ['boolean', ['feature-state', 'ShowArea'], ['any', ['==', ['get', 'status'], 1], ['==', ['get', 'status'], 2]]],
                    0.3,
                    0
                ]
            }
        });

        // Módulos
        this.map.addLayer({
            id: 'unclustered-modulos',
            type: 'symbol',
            source: 'points',
            filter: [
                "any",
                ['==', 'icon', '0a22e8ed-42c1-496c-8d0a-82a4e05371c1'], // Módulo
            ],
            layout: {
                "icon-image":  [
                    'case',
                    this.status[0],
                    'green',
                    this.status[1],
                    'yellow',
                    this.status[2],
                    'red',
                    this.status[3],
                    'purple',
                    this.status[4],
                    'orange',
                    'purple'
                ],
                'icon-size': 1,
                'icon-allow-overlap': true,
            },
        });

        // Analisadores
        this.map.addLayer({
            id: 'unclustered-Poco',
            type: 'symbol',
            source: 'points',
            filter: [
                "all",
                ['==', 'icon', '1f4d0674-1e7a-48c5-925f-87e2d99bcda5'], // Poço
            ],
            layout: {
                "icon-image":  [
                    'case',
                    this.status[0],
                    'generalGreen',
                    this.status[1],
                    'generalYellow',
                    this.status[2],
                    'generalRed',
                    this.status[3],
                    'generalPurple',
                    this.status[4],
                    'generalOrange',
                    'green'
                ],
                'icon-size': 1,
                'icon-allow-overlap': true,
                // 'icon-offset': [10, -5],
            },
        });

        // ETAs
        this.map.addLayer({
            id: 'unclustered-eta',
            type: 'symbol',
            source: 'points',
            filter: [
                "any",
                ['==', 'icon', 'e2a17428-badd-4b2a-ace9-7f428f78cc1f'], // ETA de reservatórios
            ],
            layout: {
                "icon-image":  [
                    'case',
                    this.status[0],
                    'etaGreen',
                    this.status[1],
                    'etaYellow',
                    this.status[2],
                    'etaRed',
                    this.status[3],
                    'etaPurple',
                    this.status[4],
                    'etaOrange',
                    'etaGray'
                ],
                'icon-size': 1,
                'icon-allow-overlap': true,
            },
        });

        // Reservatórios 
        this.map.addLayer({
            id: 'unclustered-reservatorio',
            type: 'symbol',
            source: 'points',
            filter: [
                'any',
                ['==', 'icon', '8831aa23-aa96-468f-bd48-10463cdaea6b'],
                ['==', 'icon', 'de4a6821-eb4c-492b-96c1-7ab704f053f6']
            ],
            layout: {
                "icon-image":  [
                    'case',
                    this.status[0],
                    'reservatoriogreen',
                    this.status[1],
                    'reservatorioYellow',
                    this.status[2],
                    'reservatorioRed',
                    this.status[3],
                    'reservatorioPurple',
                    this.status[4],
                    'reservatorioOrange',
                    'reservatorioPurple'
                ],
                'icon-size': 0.8,
                'icon-allow-overlap': true,
            },
        });

        // Macro medidores
        this.map.addLayer({
            id: 'unclustered-Macro',
            type: 'symbol',
            source: 'points',
            filter: [
                'any',
                ['==', 'icon', '782e9b76-5a92-4ad4-ba2a-5a6f84cb9ae1'],
                ['==', 'icon', 'd0effc9e-4b90-4212-b800-4fb17cd5f67a'],
            ],
            layout: {
                "icon-image":  [
                    'case',
                    this.status[0],
                    'vazaoGreen',
                    this.status[1],
                    'vazaoYellow',
                    this.status[2],
                    'vazaoRed',
                    this.status[3],
                    'vazaoPurple',
                    'vazaoGray',
                ],
                'icon-size': 1,
                'icon-allow-overlap': true,
            },
        });

        // Sensor de nível
        this.map.addLayer({
            id: 'unclustered-level',
            type: 'symbol',
            source: 'points',
            filter: [
                'any',
                ['==', 'icon', 'ce27f1ab-2a42-45a2-a5c1-2a4e498b90d6'],
                ['==', 'icon', 'sensor de nivel'],
            ],
            layout: {
                "icon-image":  [
                    'case',
                    this.status[0],
                    'levelGreen',
                    this.status[1],
                    'levelYellow',
                    this.status[2],
                    'levelRed',
                    this.status[3],
                    'levelPurple',
                    'levelGray',
                ],
                'icon-size': 1,
                'icon-allow-overlap': true,
            },
        });

        // Sensor de pressão
        this.map.addLayer({
            id: 'unclustered-pressure',
            type: 'symbol',
            source: 'points',
            filter: [
                'any',
                // TODO
                ['==', 'icon', 'sensor de pressão'],
            ],
            layout: {
                "icon-image":  [
                    'case',
                    this.status[0],
                    'pressureGreen',
                    this.status[1],
                    'pressureYellow',
                    this.status[2],
                    'pressureRed',
                    this.status[3],
                    'pressurePurple',
                    'pressureGray',
                ],
                'icon-size': 1,
                'icon-allow-overlap': true,
            },
        });

        // Novos tipos de equipamentos
        this.map.addLayer({
            id: 'unclustered-equipamentos',
            type: 'symbol',
            source: 'points',
            filter:  [
                "any",
                ['==', 'icon', '52e63208-66ed-4a57-b41f-6f93b1b12f76'], // Equipamento tipo LoRaWAN
            ],
            layout: {
                "icon-image":  [
                    'case',
                    this.status[0],
                    'green',
                    this.status[1],
                    'yellow',
                    this.status[2],
                    'red',
                    this.status[3],
                    'purple',
                    this.status[4],
                    'orange',
                    'purple'
                ],
                'icon-size': 1,
                'icon-allow-overlap': true,
            },
        });
        
        // Textos azuis
        this.map.addLayer({
            id: 'Text-Blue',
            type: 'symbol',
            source: 'points',
            layout: {
                'text-field': ['get', 'name'],
                'text-size': 12,
                'text-anchor': 'center',
                'text-justify': 'center',
                'icon-allow-overlap': true,
                'text-font':  ["Roboto Bold"],
                'text-offset': [
                    "case",
                    ["==", ["get", "icon"], "de4a6821-eb4c-492b-96c1-7ab704f053f6"],
                    ["literal", [0, 2.5]],
                    ["==", ["get", "icon"], "8831aa23-aa96-468f-bd48-10463cdaea6b"],
                    ["literal", [0, 2.5]],
                    ["==", ["get", "icon"], "d0effc9e-4b90-4212-b800-4fb17cd5f67a"],
                    ["literal", [0, 2.3]],
                    ["literal", [0, 3.5]]
                    
                ],

            },
            paint: {
                'text-color': '#333',
            },
        });

        // bio
        // response
        this.map.addLayer({
            id: 'unclustered-response',
            type: 'symbol',
            source: 'points',
            filter: [
                "any",
                ['==', 'icon', '32e9ece4-dc87-4ec5-b565-82fcab16511a'],
            ],
            layout: {
                "icon-image": 'absorptionBarrier',
                'icon-size': 1,
                'icon-allow-overlap': true,
            },
        });

        // dust
        this.map.addLayer({
            id: 'unclustered-dust',
            type: 'symbol',
            source: 'points',
            filter: [
                "any",
                ['==', 'icon', 'c71db0ce-7496-459d-9cb5-e24e8f5eba5b'],
            ],
            layout: {
                "icon-image": 'dustSuppressor',
                'icon-size': 1,
                'icon-allow-overlap': true,
            },
        });

        // MPF
        this.map.addLayer({
            id: 'unclustered-mpf',
            type: 'symbol',
            source: 'points',
            filter: [
                "any",
                ['==', 'icon', 'cfc1f45f-4599-48a1-8685-5c589c96909d'],
            ],
            layout: {
                "icon-image": 'green',
                'icon-size': 1,
                'icon-allow-overlap': true,
            },
        });

        // Cluster
        this.map.addLayer({
            id: 'clusters',
            type: 'circle',
            source: 'points',
            filter: ['has', 'point_count'],
            paint: {
                'circle-color': 'transparent',
                'circle-radius': 20,
            },
        });
    }

    /**
     * Converte a lista para o formato desejado
     * @returns {Object} Lista de equipamentos
     */
    async createList(data){
        let list = [];
        let ListLines = {
            'type': 'FeatureCollection',
            'features': []
        }; 
        let listAreas = {
            'type': 'FeatureCollection',
            'features': []
        };

        data.equipments?.map(equipamento=>{
            list.push({
                'name': equipamento.name,
                "type": equipamento.type.id, 
                "properties": { 
                    "id": equipamento.id, 
                    "name": equipamento.name, 
                    "type": equipamento.type.id,
                    "icon": equipamento.id_icon_type ? equipamento.id_icon_type : equipamento.type.id, 
                    'status': equipamento.status === 0 || equipamento.status ? equipamento.status : 5, 
                }, 
                "geometry": { "type": equipamento.type.id, "coordinates": [equipamento.coordinates.longitude, equipamento.coordinates.latitude]},
            })
            if(equipamento?.supply_lines){
                equipamento.supply_lines.map(line=>{
                    ListLines.features.push(
                        {
                            'type': 'Feature',
                            'geometry': {
                                'type': 'LineString',
                                'properties': {},
                                'coordinates': line.line.coordinates
                            },
                            'properties':{
                                'id': equipamento.id,
                                'status': equipamento.status,
                            }
                        }
                    )
                    return line
                })
            }
            if(equipamento?.supply_areas){
                equipamento.supply_areas.map(area=>{
                    listAreas.features.push(
                        {
                            'type': 'Feature',
                            'geometry': {
                                'type': 'Polygon',
                                'properties': {},
                                'coordinates': area.area.coordinates
                            },
                            'properties':{
                                'id': equipamento.id,
                                'status': equipamento.status,
                            }
                        }
                    )
                    return area
                })
            }
            return equipamento
        });

        data.grouppings?.map(groupping => {
            list.push({
                "type": 'TEMPGROUP', 
                "properties": { 
                    "id": groupping.id, 
                    "name": groupping.name, 
                    "type": 'TEMPGROUP',
                    "icon": groupping.id_icon_type,
                    'status': groupping.status === 0 || groupping.status ? groupping.status : 5
                }, 
                "geometry": { "type": 'TEMPGROUP', "coordinates": [groupping.coordinates.longitude, groupping.coordinates.latitude]},
            })
            if(groupping?.supply_lines){
                groupping.supply_lines.map(line=>{
                    ListLines.features.push(
                        {
                            'type': 'Feature',
                            'geometry': {
                                'type': 'LineString',
                                'properties': {},
                                'coordinates': line.line.coordinates
                            },
                            'properties':{
                                'id': groupping.id,
                                'status': groupping.status,
                            }
                        }
                    )
                    return line
                })
            }
            if(groupping?.supply_areas){
                groupping.supply_areas.map(area=>{
                    listAreas.features.push(
                        {
                            'type': 'Feature',
                            'geometry': {
                                'type': 'Polygon',
                                'properties': {},
                                'coordinates': area.area.coordinates
                            },
                            'properties':{
                                'id': groupping.id,
                                'status': groupping.status,
                            }
                        }
                    )
                    return area
                })
            }
            return groupping
        });

        this.Lines = ListLines;
        this.Areas = listAreas;
        this.data = list;
    }

    async handleDataRequest(id, groupFlag){
        try {

            this.checkRequest[id] = this.mapRequests.RequestData(id, groupFlag);
            this.popupData = await this.checkRequest[id];
            this.popupData.data = await this.addTimeAnalise(this.popupData.data)
            let newdados = this.popupData.data;

            if(newdados){
                this.popupData.time = getEquipamentTime(this.popupData.timestampLastMessage)
                store.dispatch(ChangeMapData(this.popupData));
            }else{
                store.dispatch(ChangeMapData([]));
            }
            store.dispatch(ChangeMapState(this.popupData.status))
            store.dispatch(ChangeMapLoading(false))
        } catch (error) {
            store.dispatch(ChangeMapData([]));
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
    }

    async handleRequestTourFlag(){
        try {
            const response = await this.mapRequests.RequestTourFlag();
            console.log(response);
        } catch (error) {
            console.log(error);
        }
    }

    /**
    * Inicia o tour
    */
    startTour() {
        const equipmentIndex = 0;

        if (this.data.length === 0) {
            toast("Cadastrar equipamento", {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return;
        }

        const equipment = this.data[equipmentIndex];
        const { id, type } = equipment.properties;
        const isTempGroup = type === 'TEMPGROUP';

        this.handleDataRequest(id, isTempGroup);
        return equipment;
    }

    /**
    * Abre popup no mapa próprio para o tour
    */
    openTourPopup(id, coordinates, properties) {
        let loading = this.createPopuploading(id)
        this.popup = new mapboxgl.Popup({
            closeButton: true,
            closeOnClick: false,
        })
            .setLngLat(coordinates)
            .setMaxWidth('350px')
            .setHTML(loading)
            .addTo(this.map);
        this.openPopups.push({
            id: id,
            popup: this.popup ,
            props: properties,
            coordinates: coordinates,
        })
        this.popup.on('close', () => {
            this.openPopups = this.openPopups.filter(currentpopup => currentpopup.id !== id)
        })
        if(coordinates && this.popup ){
            this.Loadpopup(this.popup, this.popupData, properties)
        }
    }

    /**
    * Fecha o popup 
    */
    closePopup() {
        this.popup.remove();
    }

    /**
     * Altera o centro do mapa
     * @param {Array} newCenter novo centro do mapa
     */
    changeMapCenter(newCenter, zoom){
        let distancia = this.calcularDistancia(newCenter)
        let duration = (distancia*60)>5999 ? 6000 : distancia*60;

        this.map.flyTo({
            center: newCenter,
            zoom: zoom ? zoom :12.5,
            duration: duration,
            essential: true
        })

        return duration;
    }

    /**
     * Calcula a distancia do centro atual para o novo centro
     * @param {Array} newCenter novo centro do mapa
     */
    calcularDistancia(newCenter) {
        const R = 6371; // Raio médio da Terra em quilômetros
        let currentCenter = this.map.getCenter();
        currentCenter = [currentCenter.lng, currentCenter.lat]
      
        const dLat = (newCenter[0] - currentCenter[0]) * (Math.PI / 180); // Diferença de latitude em radianos
        const dLon = (newCenter[1] - currentCenter[1]) * (Math.PI / 180); // Diferença de longitude em radianos
      
        const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                  Math.cos(currentCenter[0] * (Math.PI / 180)) * Math.cos(newCenter[0] * (Math.PI / 180)) *
                  Math.sin(dLon/2) * Math.sin(dLon/2);
      
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      
        const distancia = R * c; // Distância em quilômetros
        return distancia;
    }

    /**
     * Atualiza os popups
     */
    updatePopups(){
        this.openPopups.map(currentpopup => {
            this.updatePopupsData(currentpopup.id, currentpopup.popup, currentpopup.props)
            return currentpopup
        })
    }

    /**
     * Requisição de dados para atualizar os popups
     */
    async updatePopupsData(id, currentpopup, props){
        let dados = []
        try {
            dados = await this.mapRequests.RequestData(id, props.type === 'TEMPGROUP');
            dados.data = await this.addTimeAnalise(dados.data)
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
        let content = this.createPopupGeneral(props, dados)
        currentpopup.setHTML(content)
        let newid = props.id.split(':')
        newid = newid.join('-')
        const buttonFix = document.getElementById('fixed-'+newid);
        const buttonModal = document.getElementById('modal-'+newid);

        if (buttonFix) {
            buttonFix.removeEventListener('click', this.fixedEquipament);

            buttonFix.addEventListener('click', () => this.fixedEquipament(props, dados, currentpopup));
        }
        if(buttonModal){
            buttonModal.removeEventListener('click', this.openModal);

            buttonModal.addEventListener('click', () => this.openModal(props, (props.type !== 'TEMPGROUP' && props.type !== "8831aa23-aa96-468f-bd48-10463cdaea6b"), props.type === 'TEMPGROUP'));
        }
    }

    /**
     * Requisição de dados para modal/popup
     */
    async GetEquipmentData(id, coordinates, props, groupFlag){
        let currentpopup = this.openPopups.find(currentpopup => currentpopup.id === id)
        if(currentpopup?.popup){
            currentpopup?.popup?.remove()
            this.openPopups = this.openPopups.filter(currentpopup => currentpopup.id !== id)
        }
        let popup 
        if(coordinates){
            let loading = this.createPopuploading(id)
            popup = new mapboxgl.Popup({
                closeButton: true,
                closeOnClick: false,
            })
                .setLngLat(coordinates)
                .setMaxWidth('350px')
                .setHTML(loading)
                .addTo(this.map);
            this.openPopups.push({
                id: id,
                popup: popup,
                props: props,
                coordinates: coordinates,
            })
            popup.on('close', () => {
                this.openPopups = this.openPopups.filter(currentpopup=> currentpopup.id !== id)
            })
        }

        let dados = []
        try {
            if(this.checkRequest[id]){
                dados = await this.checkRequest[id];
                if(dados?.horario && !this.isTourOpen){
                    let currentTime = new Date().getTime();

                    if(Math.abs(currentTime - new Date(dados.horario).getTime()) > 8000){
                        this.checkRequest[id] = this.mapRequests.RequestData(id, groupFlag);
                        dados = await this.checkRequest[id];
                        dados.data = await this.addTimeAnalise(dados.data)
                    }
                }
            }else{
                this.checkRequest[id] = this.mapRequests.RequestData(id, groupFlag);
                dados = await this.checkRequest[id];
                dados.data = await this.addTimeAnalise(dados.data)
            }
            let newdados = dados.data;

            if(newdados){
                dados.time = getEquipamentTime(dados.timestampLastMessage)
                store.dispatch(ChangeMapData(JSON.parse(JSON.stringify(dados))));
            }else{
                store.dispatch(ChangeMapData([]));
            }
            store.dispatch(ChangeMapState(dados.status))
            store.dispatch(ChangeMapLoading(false))
        } catch (error) {
            store.dispatch(ChangeMapData([]));
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }

        
        if(coordinates && popup){
            this.Loadpopup(popup, dados, props)
        }
        this.updateEquipamentOnList(props, dados)
    }

    async addTimeAnalise(data){
        let newdata = data;
        let priority = this.priority.filter(item => newdata.some(obj => obj.name.includes(item)));
        priority = new Map(priority.map((item, index) => [item, index]));
        newdata.sort((a, b) => {
            const aKey = a.name;
            const bKey = b.name;
            const getPriority = (key) => {
                for (let [priorityKey, priorityValue] of priority) {
                    if (key.includes(priorityKey)) {
                        return priorityValue;
                    }
                }
                return Infinity; 
            };
            const aPriority = getPriority(aKey);
            const bPriority = getPriority(bKey);
            if (aPriority !== bPriority) {
                return aPriority - bPriority;
            }        
            // Ordem alfabética como critério secundário
            return aKey.localeCompare(bKey);
        });
        for (let i = 0; i < newdata.length; i++) {
            let variavel = newdata[i];
    
            if (variavel.name.includes('Cloro Livre') || variavel.name.includes('Fluoreto') || variavel.name.includes('Turbidez')) {
                newdata.splice(i + 1, 0, {
                    name: 'Horário da Análise',
                    status: variavel.dateLastAnalysis ? variavel.status : 5,
                    value: variavel.dateLastAnalysis ? this.getTimeData(variavel.dateLastAnalysis) : 'Sem Dados',
                    unit: '',
                    isData: true,
                });

                i++;
            }
        }
        return newdata
    }

    // retorna data HH:MM - DD/MM/AAAA
    getTimeData(time){
        let date = new Date(time)
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();
        return `${hours}:${minutes < 10 ? '0'+minutes : minutes} - ${day < 10 ? '0'+day : day}/${month < 10 ? '0'+month : month}/${year}`
    }

    // inserção do conteudo no popup
    Loadpopup(popup, dados, props){
        let content = this.createPopupGeneral(props, dados)
        popup.setMaxWidth('350px')
        popup.setHTML(content)
        let id = props.id.split(':')
        id = id.join('-')
        const buttonFix = document.getElementById('fixed-'+id);
        const buttonModal = document.getElementById('modal-'+id);

        const buttonClose = document.querySelector('.hidden-close__button');

        if (buttonFix) {
            buttonFix.removeEventListener('click', this.fixedEquipament);

            buttonFix.addEventListener('click', () => this.fixedEquipament(props, dados, popup));
        }
        if(buttonModal){
            buttonModal.removeEventListener('click', this.openModal);

            buttonModal.addEventListener('click', () => this.openModal(props, (props.type !== 'TEMPGROUP' && props.type !== "8831aa23-aa96-468f-bd48-10463cdaea6b"), props.type === 'TEMPGROUP'));
        }
        if (buttonClose) {
            buttonClose.addEventListener('click', () => this.closePopup());
        }
    }

    /**
     * Cria o popup de loading
     */
    createPopuploading(){
        return(`
            <div style="text-align: center;">
                <div class="spinner"></div>
            </div>
            <style>
                .spinner {
                    border: 4px solid rgba(0, 0, 0, 0.1);
                    border-left-color: #333;
                    border-radius: 50%;
                    width: 30px;
                    height: 30px;
                    animation: spin 1s linear infinite;
                    margin: 20px auto;
                }
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            </style>
        `);
    }

    // Criação do conteudo do popup da eta
    createPopupGeneral(props, dados){
        let array = dados.data ? dados.data : [];
        let id = props.id.split(':');
        id = id.join('-');
        let titleBackgroundColor = props?.status === 4 ? '#E1800E' 
            : props.status === 3 ? '#6600CC' 
            : props.status === 2 ? '#FF3939'
            : props.status === 1 ? '#EABC1A'
            : props.status === 0 ? '#33CC99'
            : '#F6F6F6';
        const timeDatePattern = /^\d{1,2}:\d{2} - \d{2}\/\d{2}\/\d{4}$/;

        const handleDate = (value) => {
            const [time, date] = value.split(' - ');
            const [hours, minutes] = time.split(":");
            const [day, month, year] = date.split("/");
            const dateObj = new Date(year, month - 1, day, hours, minutes);
            return i18n.t("date.hour-date", {date: new Date(dateObj), format: "hourAndDate"})
        }
        
        return (`
            <div id="map-popup" style="display: flex; flex-direction: column; padding: 5px; gap: 5px; margin: 5px;">
                <style>
                    .popup-title-${id}{
                        background: ${titleBackgroundColor};
                        color: #FFF;
                        text-align: center;
                        font-size: 18px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: normal;
                        border-radius: 15px;
                        padding: 5px;
                    }
                    .name{
                        white-space: nowrap;
                        width: 48%;
                        min-width: 135px;
                        color: #4361EE;
                        font-size: 15px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: normal;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .value{
                        white-space: nowrap;
                        width: 23%;
                        min-width: 45px;
                        color: #4361EE;
                        font-size: 15px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: normal;
                    }
                    .value-max{
                        white-space: nowrap;
                        width: 23%;
                        min-width: 70px;
                        color: #4361EE;
                        font-size: 15px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: normal;
                    }
                    .unit{
                        white-space: nowrap;
                        width: 20%;
                        min-width: 30px;
                        color: #4361EE;
                        font-size: 15px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: normal;
                    }
                    .FavoriteButton{
                        background-color: transparent;
                        color: #4361EE;
                        font-size: 15px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: normal;
                        border: 1px solid #4361EE;
                        border-radius: 5px;
                        padding: 5px;
                        cursor: pointer;
                        transition: 0.5s;   
                        width: 45%;
                        min-width: fit-content;
                        @media (max-width: 1000px) {
                            display: none;
                        }
                    }
                    .FavoriteButton:hover{
                        background-color: #4361EE;
                        color: #FFF;
                    }
                    .buttonContainer{
                        display: flex;
                        flex-direction: row;
                        gap: 5px;
                        justify-content: center;
                    }
                    .hidden-close__button{
                       display: none;
                    }
                </style>  
                <button class="hidden-close__button"></button>              
                <h1 class="popup-title-${id}">${props.name}</h1>
                <div style="display: flex; flex-direction: column; gap: 5px; max-height: 195px; overflow-y: auto; overflow-x:hidden; padding: 5px;">
                    ${array.map((item, index) => `
                    <div style="background-color: ${index % 2 === 0 ? '#F6F6F6' : '#FFF'}; white-space: nowrap; display: flex; flex-direction: row; padding: 5px; gap: 5px;">
                        <span class="name">${item.name}:</span>
                        <span class=${array.some(obj => obj.hasOwnProperty("value2")) ? "value-max": "value"}>${timeDatePattern.test(item.value)?  handleDate(item.value) : item.value}</span>
                        ${item.value2 || array.some(obj => obj.hasOwnProperty("value2")) ? `<span class="value">${item.value2 ? item.value2 : item.unit}</span>` 
                            : `<span class="unit">${item.unit}</span>`}
                        
                    </div>`).join('')}
                </div>
                <div class="buttonContainer">
                    <button class="FavoriteButton pin-button" id="fixed-${id}">${i18n.t("buttons.pin")}</button>
                    <button class="FavoriteButton expand-button" id="modal-${id}">${i18n.t("buttons.expand")}</button>
                </div>
            </div>
        `)
    }

    // Fixa os dados do equipamento em uma lista na direita da tela
    fixedEquipament(props, dados, popup){
        let equipamentDataList = JSON.parse(JSON.stringify(store.getState().mapReducer.EquipamentDataList))
        equipamentDataList = equipamentDataList.filter(equipament => equipament.id !== props.id)
        equipamentDataList.unshift({
            props: props,
            id: props.id,
            name: props.name,
            type: props.type,
            data: dados.data ? dados.data : [],
            status : dados.status ? dados.status : 3
        })
        store.dispatch(ChangeEquipamentDataList(equipamentDataList))

        popup.remove()
        this.openPopups.filter(currentpopup => currentpopup.id !== props.id)
    }

    // atualiza toda a lista de equipamentos fixados
    updatefixedList(){
        let equipamentDataList = JSON.parse(JSON.stringify(store.getState().mapReducer.EquipamentDataList))
        equipamentDataList.map(equipament=>{
            this.GetEquipmentData(equipament.id, null, equipament.props)
            return equipament
        })
        store.dispatch(ChangeEquipamentDataList(equipamentDataList))
    }

    // Atualiza um equipamento na lista de equipamentos fixados
    updateEquipamentOnList(props, dados){
        let equipamentDataList = JSON.parse(JSON.stringify(store.getState().mapReducer.EquipamentDataList))
        if(equipamentDataList.find(equipament => equipament.id === props?.id)){
            equipamentDataList.find(equipament => equipament.id === props.id).status = dados.status
            equipamentDataList.find(equipament => equipament.id === props.id).data = dados.data
        }
        store.dispatch(ChangeEquipamentDataList(equipamentDataList))
    }
}